import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorShippingItemList = () => {
  const { t } = useTranslation()
  const shippingItemList = useCallback(
    (payload, callback, loading) => {
      ApiService.jsonRequest('/transaction-shipping-item/list', payload, (response) => {
        if (response.status_code === 200) {
          if (response.data) {
            callback(response.data)
          } else {
            showAlert({
              icon: 'error',
              message: t('response_message.shipping_item_summary_failed'),
              timer: 2000,
              reload: true,
            })
          }
        }
        loading(false)
      })
    },
    [t],
  )
  return { shippingItemList }
}

export default InteractorShippingItemList
